import { HeroSectionContainer } from './HeroSectionWrapper.styles';

interface HeroSectionWrapperProps {
  imageSrc: string;
  imageAlt: string;
  imageWidth: string;
  translateY?: string;
  isSignedIn?: boolean;
}

export const HeroSectionWrapper = ({
  imageSrc,
  imageAlt,
  imageWidth,
  translateY,
  isSignedIn = false,
}: HeroSectionWrapperProps) => {
  return (
    <HeroSectionContainer isSignedIn={isSignedIn} {...(translateY && { translateY })}>
      <img src={imageSrc} alt={imageAlt} style={{ width: imageWidth }} className="hero-image" />
    </HeroSectionContainer>
  );
};
